import CheckoutCard from "@/components/checkout-card";
import AuthPageTitle from "@/components/layout/auth-page-title";

const SubscriptionPage = () => {
  const isProduction = import.meta.env.VITE_NODE_ENV === "production";

  const monthlyPriceId = isProduction
    ? "price_1SexZLFDjE9cPZZTp5WcK8Q1"
    : "price_1SebwnFZ7CP02e8kMH8aD6bz";
  const yearlyPriceId = isProduction
    ? "price_1SexZLFDjE9cPZZThXk0rEVX"
    : "price_1SebwnFZ7CP02e8kK7G8jj9v";

  return (
    <div className="flex flex-col py-10 px-[10%] gap-[80px]">
      <AuthPageTitle
        title={"Choisissez un abonnement"}
        subTitle={
          "Choisissez un abonnement pour accéder à l'ensemble des fonctionnalités de l'application"
        }
      />
      <div className="flex flex-row gap-8 w-full">
        <CheckoutCard
          title={"Abonnement complet"}
          monthlyPriceId={monthlyPriceId}
          monthlyPrice={69}
          yearlyPriceId={yearlyPriceId}
          yearlyPrice={699}
          features={[
            "Suivi des fiches patients",
            "Application mobile pour vos patients",
            "Accès complet à l'application",
          ]}
          highlighted
        />
      </div>
    </div>
  );
};

export default SubscriptionPage;
